import DownloadManagement from "./statistical-management.page";

export default DownloadManagement;
